import { displayShell } from './boot/displayShell';
import { registerServiceWorker } from './pwa/registerSw';
import { LOADING_TEXT } from './boot/loadingModel';
import { loadingScreen } from './boot/loadingScreen';
import { markStartup } from './boot/startupMarks';

type GameModule = typeof import('./startGame');

const loadGame = (): Promise<GameModule> => import('./startGame');

/** Starts the game once its code is here; if the download failed, the loading screen offers a retry. */
async function launch(game: Promise<GameModule>): Promise<void> {
  let mod: GameModule;
  try {
    mod = await game.catch(loadGame);
  } catch {
    loadingScreen.fail({ code: 'GAME-CODE', retry: () => void launch(loadGame()) });
    return;
  }
  mod.startGame();
}

/** Temporary public-access mode: bypass the birthday gate while retaining its implementation for later restoration. */
async function boot(): Promise<void> {
  markStartup('boot');
  displayShell.install();
  registerServiceWorker();
  void import('./game/cloud/firebase/FirebaseAuthBootstrap').then(({ initializeFirebaseAuth }) => initializeFirebaseAuth());
  loadingScreen.show(LOADING_TEXT.preparing);
  const game = loadGame();
  game.then(() => markStartup('game-module-loaded')).catch(() => undefined);
  await launch(game);
}

void boot();
